import ReactGA from "react-ga4";
import { GaOptions, InitOptions, UaEventOptions } from "react-ga4/types/ga4";

const actions = {
    reset: (): void => {
        ReactGA.reset();
    },
    initialize: (id: string | InitOptions[]) => {
        ReactGA.initialize(id);
    },
    set: (fieldsObject: GaOptions | any): void => {
        ReactGA.set(fieldsObject);
    },
    event: (optionsOrName: UaEventOptions | string, params?: any): void => {
        optionsOrName = {
            ...(optionsOrName as UaEventOptions),
            label: window.location.toString()
        };
        ReactGA.event(optionsOrName, params);
    },
    send: (fieldObject: any): void => {
        ReactGA.send(fieldObject);
    }
};

export const ReactGa = actions;
